import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './bootstrap-grid.min.css';
import Stream from './components/Stream';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';


class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <div className="App">
          <header className="App-header">
            <h1 className="App-title"><b>Family</b>Room</h1>
          </header>
          <div className="row">
            <div className="col-md-12">
              <Stream />
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js